<div class="transactions">
  <div class="transactions__title">
    Последние операции
  </div>
  <table class="transactions__table">
    <thead>
    <tr>
      <th class="heading">Дата / Время</th>
      <th class="heading">Было</th>
      <th class="heading heading__amount heading__amount_income"><i class="fa fa-caret-up"></i></th>
      <th class="heading heading__amount heading__amount_outcome"><i class="fa fa-caret-down"></i></th>
      <th class="heading">Стало</th>
      <th class="heading">Описание</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let transaction of transactions" class="data">
      <td class="data__date">
        <span class="data__date_day">{{ transaction.date | date: 'dd.MM'}}</span>
        <span class="data__date_time">{{transaction.date | date: 'HH:mm'}}</span>
      </td>
      <td>{{ transaction.amount_before }}</td>
      <td class="data__income">
        {{ transaction.operation === operation.CASH_IN ? transaction.amount : "" }}
      </td>
      <td class="data__outcome">
        {{ transaction.operation === operation.CASH_OUT ? transaction.amount : "" }}
      </td>
      <td>{{ transaction.amount_after }}</td>
      <td class="data__description">
        {{transaction.comment}}
      </td>
    </tr>
    </tbody>
    <tfoot>
    <tr *ngIf="transactions.length === 0">
      <td colspan="6" class="transactions__no-transactions">
        Транзакций нет!
      </td>
    </tr>
    </tfoot>
  </table>
  <app-pagination 
    class="pagination"
    *ngIf="totalPages > 1"
    [totalPages]="totalPages" 
    [currentPage]="currentPage"
    (pageChange)="changePage($event)">
  </app-pagination>
</div>
